import React from "react";
import { ArrowRight } from "lucide-react";
import Logo from "../Logo";

const HERO_IMG =
  "https://images.pexels.com/photos/20337607/pexels-photo-20337607.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=1400";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden bg-black text-white"
    >
      {/* Background planet image - right side bleed */}
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute top-0 right-0 h-full w-full md:w-[70%] bg-no-repeat bg-cover bg-center grayscale opacity-80"
          style={{
            backgroundImage: `url('${HERO_IMG}')`,
            maskImage:
              "linear-gradient(to right, transparent 0%, black 35%, black 100%)",
            WebkitMaskImage:
              "linear-gradient(to right, transparent 0%, black 35%, black 100%)",
          }}
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/60 to-transparent" />
        <div className="absolute inset-0 bg-black/30" />
      </div>

      {/* Vertical side label */}
      <div className="absolute left-6 top-1/2 -translate-y-1/2 hidden lg:block z-10">
        <span className="vertical-rl font-mono text-[10px] tracking-[0.5em] uppercase text-zinc-500">
          EST · CAMO INTELLIGENCE · MMXXV
        </span>
      </div>

      {/* Right vertical marker */}
      <div className="absolute right-6 top-1/2 -translate-y-1/2 hidden lg:block z-10">
        <span className="vertical-rl font-mono text-[10px] tracking-[0.5em] uppercase text-zinc-500">
          PRIVATE · DIGITAL · OPERATIONS
        </span>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 pt-40 md:pt-44 pb-24 min-h-screen flex flex-col justify-center">
        <div className="reveal max-w-3xl">
          <div className="mb-8 flex items-center gap-4">
            <Logo size="md" />
          </div>

          <div className="mb-6 flex items-center gap-3">
            <span className="h-px w-10 bg-zinc-600" />
            <span className="font-mono text-[10px] md:text-xs tracking-[0.4em] uppercase text-zinc-400">
              A Private Operations Firm
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display font-light uppercase leading-[0.95] tracking-tight text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl"
          >
            Private<br />
            Digital<br />
            Operations
          </h1>

          <div className="mt-8 font-mono text-xs md:text-sm tracking-[0.4em] uppercase text-zinc-300">
            Growth <span className="text-zinc-600 mx-2">·</span> Intelligence
            <span className="text-zinc-600 mx-2">·</span> Protection
          </div>

          <p className="mt-8 max-w-xl font-sans text-base md:text-lg leading-relaxed text-zinc-400">
            Supporting creators, businesses and organizations through strategic
            digital operations.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <a
              href="#membership"
              data-testid="hero-primary-cta"
              className="group inline-flex items-center justify-between gap-6 bg-white text-black font-mono uppercase text-[11px] tracking-[0.3em] px-8 py-5 hover:bg-zinc-200 transition-colors duration-300"
            >
              <span>Become a Member</span>
              <ArrowRight
                size={16}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </a>
            <a
              href="#contact"
              data-testid="hero-secondary-cta"
              className="group inline-flex items-center justify-between gap-6 border border-white text-white font-mono uppercase text-[11px] tracking-[0.3em] px-8 py-5 hover:bg-white hover:text-black transition-colors duration-300"
            >
              <span>Book a Consultation</span>
              <ArrowRight
                size={16}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-3 text-zinc-500">
        <span className="font-mono text-[10px] tracking-[0.4em] uppercase">
          Scroll
        </span>
        <span className="h-10 w-px bg-zinc-700 animate-pulse" />
      </div>
    </section>
  );
};

export default Hero;
